import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { FormSmallTextInput } from '../../inputs/SmallTextInput';

import { ICreateMeetingShortcut } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useParams } from 'react-router-dom';
import {
  meetingShortcutUpdate,
  teamFilesCreateFilelMeetingDashboardPage,
} from '../../../../../app/page/meeting-dashboard/meeting-dashboard.actions';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingFilesSelectedSelectors } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';
import { IMeetingShortcutFormProps } from './types';

export const MeetingShortcutAddFileForm: FunctionComponent<IMeetingShortcutFormProps> = ({ shortcut }) => {
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();

  const [meetingShortcutsSelected] = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceList, meetingId);

  const dispatch = useDispatch();

  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = ({ externalLink, description, name }: ICreateMeetingShortcut) => {
    if (!shortcut) {
      dispatch(
        teamFilesCreateFilelMeetingDashboardPage(
          meetingId,
          externalLink,
          description,
          meetingShortcutsSelected?.id,
          name,
        ),
      );
    } else {
      dispatch(
        meetingShortcutUpdate(shortcut.id, {
          meetingId,
          externalLink,
          description,
          folderId: meetingShortcutsSelected?.id,
          name,
        }),
      );
    }
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="meeting-shortcuts-add-file-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit((formData as unknown) as ICreateMeetingShortcut))}
        method="post"
      >
        <div className="field-container">
          <FormSmallTextInput
            id="name"
            name="name"
            type="text"
            label="Shortcut Name"
            placeholder="Your shortcut name..."
            validation={requiredValidation}
            defaultValue={shortcut ? shortcut.filename : ''}
          />
        </div>
        <div className="field-container">
          <FormSmallTextInput
            id="externalLink"
            name="externalLink"
            type="text"
            label="Shortcut URL"
            placeholder="Paste the URL here..."
            validation={requiredValidation}
            defaultValue={shortcut ? shortcut.url : ''}
          />
        </div>

        <div className="field-container">
          <FormSmallTextInput
            id="description"
            name="description"
            multi={true}
            label="URL Description"
            placeholder="Description for URL..."
            defaultValue={shortcut ? shortcut.description : ''}
          />
        </div>
      </form>
    </FormProvider>
  );
};
